import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getPassTypeList = async ({ companyCode, isTrue = true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.PassTypeAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getPassTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.PassTypeAPI}?isAll=false&isTrue=true&CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

const insertPassType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.PassTypeAPI, input);
  return data;
};

const updatePassType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.PassTypeAPI, input);
  return data;
};

const deletePassType = async ({code, companyCode}) => {
  const { data } = await http_payroll.delete(`${Api_EndPoints.PassTypeAPI}?code=${code}&CompanyCode=${companyCode}`);
  return data;
};

export const useGetPassTypeQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.PassTypeAPI],
    queryFn: () => getPassTypeList(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useGetPassTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.PassTypeAPI],
    queryFn: () => getPassTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertPassTypeMutation = () => {
  return useMutation({
    mutationFn: insertPassType,
  });
};

export const useUpdatePassTypeMutation = () => {
  return useMutation({
    mutationFn: updatePassType,
  });
};

export const useDeletePassTypeMutation = () => {
  return useMutation({
    mutationFn: deletePassType,
  });
};
